export default __webpack_public_path__ + "static/media/fonf.a6ad3f3e.jpg";